module.exports = __webpack_public_path__ + "static/media/icons_Bilan Rachis Cervical.3adadc10.svg";